<template>
  <icon-svg-base
    :view-width="20"
    :view-height="20"
    class="icon"
  >
    <polyline
      :stroke-width="strokeWidth"
      :transform="transform"
      points="5.5 1 14.5 10 5.5 19"
      class="icon__bracket"
    />
  </icon-svg-base>
</template>

<script>
import VueTypes from 'vue-types';
import IconSvgBase from '@/mikan/_shared/components/atoms/icons/IconSvgBase.vue';

export default {
  components: {
    IconSvgBase,
  },
  props: {
    isThin: {
      type: Boolean,
      default: false,
    },
    direction: VueTypes.oneOf(['top', 'bottom', 'right', 'left']).def('right'),
  },
  computed: {
    strokeWidth() {
      return this.isThin ? 2 : 4;
    },
    transform() {
      const rotationMap = {
        top: -90,
        bottom: 90,
        left: -180,
        right: 0,
      };

      return `rotate(${rotationMap[this.direction]} 10 10)`;
    },
  },
};
</script>

<style lang="scss" scoped>
.icon {
  width: 1em;
  height: 1em;

  &__bracket {
    fill: transparent;
    stroke: currentColor;
  }
}
</style>
